module.exports = __webpack_public_path__ + "static/testimonialLayout3Front-977a5fb8505a39d5d3d6b35ff6c8bc64.png";